<template>
    <div class="mb-3">
      <label class="form-label">{{ label }}</label>
      <div class="form-icon position-relative">
        <i data-feather="user" class="fea icon-sm icons"></i>
        <input
          :value="modelValue"
          @input="updateValue"
          type="text"
          class="form-control ps-5"
          :class="{ 'is-invalid': modelError }"
          :placeholder="placeholder"
          :required="required"
          :readonly="readonly"
        />
      </div>
    </div>
</template>
  
  <script>
export default {
  name: "ProfileInput",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    modelError: {
        type: Boolean,
      required: false,
      default: 0
    },
    label: {
        type: String,
        required: false,
        default: null
    },
    placeholder: {
        type: String,
        required: false,
        default: null
    },
    required: {
        type: Boolean,
        required: false,
        default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    updateValue(event) {
        this.$emit("update:modelValue", event.target.value);
    },
  },
};
</script>